import React from 'react'
import VipLayout from '../../../components/vip/VipLayout'

const ContentLicensesPage: React.FC = () => {
  return (
    <VipLayout>
      <main>
        <section className="hero">
          <div className="container">
            <span className="kicker">Content / Audio-Video / AIGC</span>
            <h1>社区 / 音视频 / AIGC 服务资质咨询</h1>
            <p>围绕内容平台、社区互动、直播演艺、音视频制作与 AIGC 服务场景，提供网络文化经营许可证、广播电视节目制作经营许可证等资质路径判断与咨询服务。</p>
            <div className="anchor-nav">
              <a href="#network-culture">网络文化经营许可证</a>
              <a href="#broadcast-tv">广播电视节目制作经营许可证</a>
              <a href="#aigc">AIGC 业务资质咨询</a>
            </div>
          </div>
        </section>
        <section className="section" id="network-culture">
          <div className="container two-col">
            <div>
              <h2 className="section-title">网络文化经营许可证咨询</h2>
              <p className="section-desc">适用于网络表演、网络演出剧（节）目、网络音乐、网络动漫等经营性互联网文化活动场景。</p>
            </div>
            <div className="card content-card">
              <ul className="list">
                <li>业务是否进入文网文审批范围的判断</li>
                <li>平台功能与经营范围整改建议</li>
                <li>申报条件核查与材料准备</li>
                <li>申报路径与补正问询支持</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="section" id="broadcast-tv">
          <div className="container two-col">
            <div className="card content-card">
              <ul className="list">
                <li>节目制作经营活动适用性判断</li>
                <li>专业人员、场地与材料条件核查</li>
                <li>申请材料撰写与流程辅导</li>
                <li>与视听证等资质的边界说明</li>
              </ul>
            </div>
            <div>
              <h2 className="section-title">广播电视节目制作经营许可证咨询</h2>
              <p className="section-desc">适用于微短剧、专题片、纪录片、网络节目、宣传片等节目制作经营活动场景。</p>
            </div>
          </div>
        </section>
        <section className="section" id="aigc">
          <div className="container">
            <h2 className="section-title">AIGC / 音视频业务资质咨询</h2>
            <div className="notice">AIGC、社区、直播、音视频平台往往不是单一资质问题，可能同时涉及 ICP / EDI、网络文化经营许可证、广播电视节目制作经营许可证、算法备案、大模型登记 / 备案等事项。我们更强调按业务形态进行组合判断，而不是简单套用单一证照。</div>
          </div>
        </section>
      </main>
    </VipLayout>
  )
}

export default ContentLicensesPage
